const config =  {
    APP_NAME:"TeckZy"
};

export default  config;